import React, { useEffect, useState } from "react";
import { useDashboard } from "../Hooks/useDashboard";
import { PROJECT_TYPES } from "../../Project/constant";

const KPICard = ({ filter }) => {
  const [data, setData] = useState([]);
  const { fetchKPI, loading } = useDashboard();

  const fetchData = async () => {
    const res = await fetchKPI({ project: filter});
    setData(res);
  };

  useEffect(() => {
    fetchData();
  }, [filter]);

  // Dummy skeleton array if loading
  const skeletonArray = new Array(2).fill(0);

  return (
    <div className="flex flex-col md:flex-row gap-4 justify-around col-span-full my-1 p-2">
      {(loading ? skeletonArray : data).map((item, index) => (
        <div
          key={index}
          className="bg-gradient-to-r shadow rounded-xl p-4 text-center space-y-4 w-full"
        >
          {/* Category */}
          <h3 className="text-gray-700 font-bold text-xl px-2">
            {loading ? (
              <div className="h-7 py-1 w-24 bg-gray-200 rounded animate-pulse mx-auto"></div>
            ) : (
              item.category
            )}
          </h3>

          {/* KPI Values */}
          <div className="flex md:flex-row w-full justify-around items-center my-2">
            {PROJECT_TYPES.map((key, idx) => (
              <span
                key={idx}
                className={`w-1/2 p-2 ${idx !== 0 ? "border-l-2" : ""}`}
              >
                {loading ? (
                  <div className="h-6 w-16 bg-gray-200 rounded animate-pulse mx-auto"></div>
                ) : (
                  <strong className="text-xl">{item?.data?.[key.value] || "-"}</strong>
                )}
                <h4 className="text-gray-500 mt-1">{key.label}</h4>
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default KPICard;
